"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskColumnWrapper = exports.TaskFlexWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
exports.TaskFlexWrapper = styled_1.default.div `
	display: flex;
	flex-direction: column;

	@media (min-width: 768px) {
		flex-direction: row;
	}
`;
exports.TaskColumnWrapper = styled_1.default.div `
	display: flex;
	flex-direction: column;
	flex: 1;
	@media (min-width: 768px) {
		&:nth-of-type(odd) {
			margin-right: 10px;
		}
		&:nth-of-type(even) {
			margin-left: 10px;
		}
	}
`;
//# sourceMappingURL=TaskColumns.js.map